module.exports = __webpack_public_path__ + "img/2.4_Students-Trainees_4_Reynolds.ce59c8becbe2f0cae87beafdacab83c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.4_Students-Trainees_4_Reynolds.png
// module id = 768
// module chunks = 0